import React from "react";
import { Link } from "react-router-dom";
import { Linkedin, Facebook, Instagram } from "lucide-react";
import { firmInfo } from "../mock";

const footerLinks = [
  { label: "Home", href: "/" },
  { label: "Estate Planning", href: "/practice-areas" },
  { label: "Our Firm", href: "/about/our-firm" },
  { label: "Meet the Attorney", href: "/about/meet-the-attorney" },
  { label: "Reviews", href: "/reviews" },
  { label: "FAQ", href: "/faq" },
  { label: "Blog", href: "/blog" },
  { label: "Contact", href: "/contact" },
  { label: "Schedule", href: "/schedule" },
  { label: "Legal Disclaimer", href: "/legal-disclaimer" },
];

const Footer = () => {
  return (
    <footer>
      <div className="bg-[#0e4070] text-[#e8edf4]">
        <div className="max-w-7xl mx-auto px-6 py-7">
          <div className="flex justify-center mb-5">
            <img
              src={firmInfo.logoHorizontal}
              alt="Lloyd Law Firm, PLLC"
              className="h-28 md:h-32 w-auto object-contain"
              style={{ mixBlendMode: "lighten" }}
            />
          </div>
          <ul className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3">
            {footerLinks.map((l) => (
              <li key={l.label}>
                <Link
                  to={l.href}
                  className="text-[14px] tracking-wide hover:text-white transition-colors"
                  style={{ fontFamily: "'Playfair Display', Georgia, serif" }}
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
          <div className="flex items-center justify-center gap-5 mt-5">
            <a
              href={firmInfo.social.linkedin}
              target="_blank"
              rel="noreferrer"
              aria-label="LinkedIn"
              className="hover:text-white transition-colors"
            >
              <Linkedin size={18} />
            </a>
            <a
              href={firmInfo.social.facebook}
              target="_blank"
              rel="noreferrer"
              aria-label="Facebook"
              className="hover:text-white transition-colors"
            >
              <Facebook size={18} />
            </a>
            <a
              href={firmInfo.social.instagram}
              target="_blank"
              rel="noreferrer"
              aria-label="Instagram"
              className="hover:text-white transition-colors"
            >
              <Instagram size={18} />
            </a>
          </div>
        </div>
      </div>

      <div className="bg-[#eef3f8] text-center py-6 px-6">
        <p
          className="text-[#1f2937] text-[13px] max-w-4xl mx-auto leading-relaxed"
          style={{ fontFamily: "'Lato', sans-serif" }}
        >
          The information on this website is for general information purposes
          only. Nothing on this site should be taken as legal advice for any
          individual case or situation.
        </p>
        <p
          className="text-[#1f2937] text-[13px] mt-1"
          style={{ fontFamily: "'Lato', sans-serif" }}
        >
          This information is not intended to create an attorney-client
          relationship.
        </p>
        <Link
          to="/privacy-policy"
          className="text-[#1e5fa3] text-[13px] mt-2 inline-block hover:underline"
        >
          Privacy Policy
        </Link>
        <p
          className="text-[#64748b] text-[12px] mt-4"
          style={{ fontFamily: "'Lato', sans-serif" }}
        >
          &copy; {new Date().getFullYear()} {firmInfo.name} All Rights Reserved.
        </p>
        <p
          className="text-[#64748b] text-[12px] mt-1"
          style={{ fontFamily: "'Lato', sans-serif" }}
        >
          Developed by{" "}
          <a
            href="https://www.techtronicsmedia.com"
            target="_blank"
            rel="noreferrer"
            className="text-[#1e5fa3] hover:underline"
          >
            Techtronics Media
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
